<template>
  <div
    class="availability-marker"
    :class="classes"
    :style="styles"
  >
    <div
      v-if="(status === 'Available' || status === 'Builder Lots') && !filtered"
      class="availability-marker__ring"
      :style="{ animationDelay: animationDelay + 'ms' }"
    ></div>
    <div v-if="status && status !== 'Unassigned'" class="availability-marker__dot">
      <fa class="check" :icon="['far', 'check']" />
      <fa class="line" :icon="['fas', 'horizontal-rule']" />
      <fa class="cross" :icon="['far', 'times']" />
      <fa class="shovel" :icon="['fas', 'shovel']" />
    </div>
  </div>
</template>
<script>
export default {
  props: ['animation-delay', 'available', 'filtered', 'property-count', 'x', 'y', 'status', 'meta'],
  computed: {
    classes () {
      let classes = {}
      // Adjust the status conditions based on what you're expecting from the CRM - or better still: adjust the properties get request on the API to standardise to something like below
      if (this.meta && this.meta.isHomeSeekerLot) {
        classes['availability-marker--homeseeker'] = (this.status === 'For Sale' || this.status === 'Available')
      } else {
        classes['availability-marker--available'] = (this.status === 'For Sale' || this.status === 'Available')
      }
      classes['availability-marker--builder'] = this.status === 'Builder Lots'
      classes['availability-marker--coming-soon'] = this.status === 'Coming Soon'
      classes['availability-marker--hold'] = this.status ===  'Hold' || this.status ===  'On Hold' || this.status ===  'Hold - Pending Signing'
      classes['availability-marker--sold'] = this.status === 'Settled' || this.status === 'Sold' || this.status === 'Unconditional' || this.status === 'Conditional' || this.status === 'Signed Pending Deposit'
      classes['availability-marker--not-released'] = this.status === 'Not Released'
      classes['availability-marker--filtered'] = this.filtered
      return classes
    },

    styles () {
      return {
        left: (this.x / 20) + 'rem',
        top: (this.y / 20) + 'rem'
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/_variables.scss";

.availability-marker {
  padding: 2rem;
  position: absolute;
  transform: translate(-1rem, -1rem);
  z-index: 1;

  &--hold {
    pointer-events: none !important;

    .availability-marker__dot {
      background-color: $marker-on-hold;
      color: $white;
      opacity: 1;

      .line {
        display: block;
        width: 60%;
      }
    }
  }

  &--sold {
    pointer-events: none !important;

    .availability-marker__dot {
      background-color: $marker-sold;
      color: $white;
      opacity: 1;

      .cross {
        display: block;
      }
    }
  }

  &--available {
    color: $marker-available;
    pointer-events: auto;

    .availability-marker__dot {
      background-color: $marker-available;
      color: $black;
      opacity: 1;

      .check {
        display: block;
      }
    }
  }

  &--builder {
    color: $marker-builder;
    pointer-events: auto;

    .availability-marker__dot {
      background-color: $marker-builder;
      color: $black;
      opacity: 1;

      .check {
        display: block;
      }
    }
  }

  &--coming-soon {
    color: $marker-builder;
    pointer-events: auto;

    .availability-marker__dot {
      background-color: $marker-builder;
      color: $black;
      opacity: 1;

      .shovel {
        display: block;
      }
    }
  }

  &--homeseeker {
    color: $marker-homeseeker;
    pointer-events: auto;

    .availability-marker__dot {
      background-color: $marker-homeseeker;
      color: $white;
      opacity: 1;

      .check {
        display: block;
      }
    }
  }

  &--filtered {
    pointer-events: none !important;
    
    .availability-marker__count,
    .availability-marker__dot {
      filter: grayscale(100%);
      opacity: .5;
    }
  }

  &--not-released {
    display: none;
    pointer-events: none !important;
  }

  &__dot {
    border-radius: 50%;
    box-shadow: -0.2rem 0.3rem 0.3rem rgba(0, 0, 0, .35);
    height: 2rem;
    // transition: all 0.3s;
    width: 2rem;    
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    svg {
      display: none;
      font-size: 1.2em;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__ring {
    border: 0.3rem solid currentColor;
    border-radius: 3rem;
    height: 2rem;
    width: 2rem;
    position: absolute;
    animation: pulsate 2s ease-out;
    animation-iteration-count: infinite; 
    opacity: 0.0;
  }

  // &__count {
  //   background-color: rgba($white, 0.75);
  //   color: $black;
  //   font-size: 1.8rem;
  //   text-align: center;
  //   // transition: all 0.3s;
  //   top: 100%;
  //   position: absolute;
  //   left: 50%;
  //   padding: 0 0.3em;
  //   transform: translateX(-50%);
  //   text-shadow:
  //   -1px -1px 0 $white,  
  //     1px -1px 0 $white,
  //     -1px 1px 0 $white,
  //     1px 1px 0 $white;
  // }
}
</style>
